module.exports = __webpack_public_path__ + "img/bradford-city-fc.eafca70e.png";